// extracted by mini-css-extract-plugin
export default {"form":"PostForm_form__ZpTAO","p":"PostForm_p__oXHla","input":"PostForm_input__HKJRE"};